// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--biXKx","dnd":"dnd--Rsy9_","inner":"inner--UNEQw"};